import React, { ChangeEvent, FC } from 'react';
import { useFormikContext } from 'formik';
import classNames from 'classnames';
import { Icon } from '@lambdacurry/component-library';

export interface SelectionButtonProps {
  type: 'checkbox' | 'radio';
  name: string;
  label: string;
  icon?: string;
  value?: any;
  checked?: boolean;
  className?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>, value: any) => void;
}

export const SelectionButton: FC<SelectionButtonProps> = ({
  type,
  name,
  label,
  icon,
  className,
  onChange,
  ...props
}) => {
  const formContext = useFormikContext();
  const fieldProps = formContext?.getFieldProps(name);
  const checked = type === 'checkbox' ? (fieldProps ? !!fieldProps.value : !!props.checked) : !!props.checked;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (typeof onChange === 'function') onChange(event, type === 'radio' ? event.target.value : event.target.checked);
    if (fieldProps?.onChange) fieldProps.onChange(event);
  };

  return (
    <label
      className={classNames(
        'selection-button',
        `selection-button--${type}`,
        [
          'relative',
          'flex',
          'flex-col',
          'md:flex-row',
          'gap-2',
          'py-3',
          'px-5',
          'border',
          'text-sm',
          'items-center',
          'cursor-pointer',
          'transition-all',
          'select-none',
          'hover:bg-brand-50',
          'hover:font-bold',
          'text-center',
          'box-border'
        ],
        {
          ['checked bg-brand-50 border-brand-300 font-bold']: checked
        },
        className
      )}
      data-cy={`selection-button-${type}`}
    >
      <Icon
        aria-hidden="true"
        name="radioChecked"
        className={classNames(
          'lc-icon-color',
          'text-brand-300',
          'absolute top-[-10px]',
          'right-[-10px]',
          'transition-all',
          'duration-200',
          {
            ['opacity-0 scale-50']: !checked
          }
        )}
      />

      {icon && <Icon aria-hidden="true" name={icon} />}

      {label}

      <input
        className="absolute -left-96 invisible opacity-0 pointer-events-none appearance-none"
        {...props}
        type={type}
        name={name}
        checked={checked}
        onChange={handleChange}
      />
    </label>
  );
};
